"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigNames = exports.CommonStrings = void 0;
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const localizeUtils_1 = require("../../../common/localizeUtils");
class CommonStrings {
    static APP_STUDIO_BOT_REGISTRATION = (0, localizeUtils_1.getLocalizedString)("plugins.bot.AppStudioBotRegistration");
}
exports.CommonStrings = CommonStrings;
class ConfigNames {
    static APPSTUDIO_TOKEN = "app studio token";
    static MESSAGE_ENDPOINT = "message endpoint";
}
exports.ConfigNames = ConfigNames;
//# sourceMappingURL=strings.js.map